import script from "./UIPanelEndSuccess.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIPanelEndSuccess.vue?vue&type=script&lang=ts&setup=true"

import "./UIPanelEndSuccess.vue?vue&type=style&index=0&id=0c986b22&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c986b22"]])

export default __exports__